import { style } from '@angular/animations';
import { Component, inject } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { PartConfigModelType, PartConfigWinchStand, PartConfigWinchStandOption } from 'app/core/model/entity-model';
import { PartConfigModelSize } from 'app/core/model/part-config-model-size';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import validationEngine from 'devextreme/ui/validation_engine';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { confirm } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-model-size-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">Model Size</h2>
        </div>
        <div class="d-flex" style="align-items: flex-start;">
            <div class="flex-fill d-flex flex-column" [ngClass]="isNew ? 'col-sm-12' : 'col-sm-10'">
                <div class="card">
                    <div class="card-body">
                        <dx-form *ngIf="modelSize" [formData]="modelSize" validationGroup="validationGroup">
                            <dxi-item itemType="group">
                                <dxi-item [label]="{ text: 'Model Type' }">
                                    <div *dxTemplate>
                                        <dx-select-box
                                            [(value)]="modelSize.partConfigModelTypeId"
                                            [items]="modelTypes"
                                            [valueExpr]="'id'"
                                            [displayExpr]="'name'"
                                            [disabled]="!canChangeModelType"
                                            (onValueChanged)="onModelTypeChanged($event)"
                                        >
                                        </dx-select-box>
                                    </div>
                                    <dxi-validation-rule type="required"> </dxi-validation-rule>
                                </dxi-item>

                                <dxi-item itemType="group" caption="Type Settings" [colCount]="2">
                                    <dxi-item
                                        dataField="partConfigModelType.hasAxles"
                                        [label]="{ text: 'Has Axles Qty. Options' }"
                                        editorType="dxCheckBox"
                                        [disabled]="true"
                                    ></dxi-item>
                                    <dxi-item
                                        dataField="partConfigModelType.hasBrakes"
                                        [label]="{ text: 'Has Brake Options' }"
                                        editorType="dxCheckBox"
                                        [disabled]="true"
                                    ></dxi-item>
                                    <dxi-item
                                        dataField="partConfigModelType.hasTailOption"
                                        [label]="{ text: 'Has Tail Option' }"
                                        editorType="dxCheckBox"
                                        [disabled]="true"
                                    ></dxi-item>
                                    <dxi-item
                                        dataField="partConfigModelType.hasPolyCarpetOption"
                                        [label]="{ text: 'Has Poly/Carpet Options' }"
                                        editorType="dxCheckBox"
                                        [disabled]="true"
                                    ></dxi-item>
                                    <dxi-item
                                        dataField="partConfigModelType.hasSuspension"
                                        [label]="{ text: 'Has Suspension Options' }"
                                        editorType="dxCheckBox"
                                        [disabled]="true"
                                    ></dxi-item>
                                    <dxi-item
                                        dataField="partConfigModelType.hasWinchStand"
                                        [label]="{ text: 'Has Winch Stand Options' }"
                                        editorType="dxCheckBox"
                                        [disabled]="true"
                                    ></dxi-item>
                                    <dxi-item
                                        dataField="partConfigModelType.hasOptions"
                                        [label]="{ text: 'Has Chain or Canoe Tree Options' }"
                                        editorType="dxCheckBox"
                                        [disabled]="true"
                                    ></dxi-item>
                                </dxi-item>

                                <dxi-item itemType="group" caption="Size Settings" [colCount]="3">
                                    <dxi-item dataField="name" [colSpan]="3">
                                        <dxi-validation-rule type="required"> </dxi-validation-rule>
                                    </dxi-item>
                                    <dxi-item dataField="description" [colSpan]="3"></dxi-item>
                                    <dxi-item [label]="{ text: 'Standard Winch Stand' }" *ngIf="modelType?.hasWinchStand || modelSize.standardWinchStandId !== null" [colSpan]="3">
                                        <div *dxTemplate>
                                            <dx-select-box
                                                [(value)]="modelSize.standardWinchStandId"
                                                [items]="winchStands"
                                                [valueExpr]="'id'"
                                                [displayExpr]="'name'"
                                                (onValueChanged)="onStandardWinchStandChanged($event)"
                                            >
                                            </dx-select-box>
                                        </div>
                                    </dxi-item>
                                    <dxi-item
                                        [label]="{ text: 'Standard Winch Stand Option' }"
                                        *ngIf="modelType?.hasWinchStand || modelSize.standardWinchStandOptionId !== null"
                                        [colSpan]="3"
                                    >
                                        <div *dxTemplate>
                                            <dx-select-box
                                                [(value)]="modelSize.standardWinchStandOptionId"
                                                [items]="winchStandOptions"
                                                [valueExpr]="'id'"
                                                [displayExpr]="'name'"
                                                [disabled]="modelSize.standardWinchStandId == null || modelSize.standardWinchStand._options.length == 0"
                                            >
                                            </dx-select-box>
                                        </div>
                                    </dxi-item>
                                    <dxi-item dataField="noAxles" [label]="{ text: 'No Axles Qty. Options' }" editorType="dxCheckBox"></dxi-item>
                                    <dxi-item dataField="noBrakeOption" editorType="dxCheckBox"></dxi-item>
                                    <dxi-item dataField="noTailOption" editorType="dxCheckBox"></dxi-item>
                                    <dxi-item dataField="noPolyCarpetOption" [label]="{ text: 'No Poly/Carpet Options' }" editorType="dxCheckBox"></dxi-item>
                                    <dxi-item dataField="noSuspension" [label]="{ text: 'No Suspension Options' }" editorType="dxCheckBox"></dxi-item>
                                    <dxi-item dataField="noWinchStand" [label]="{ text: 'No Winch Stand Options' }" editorType="dxCheckBox"></dxi-item>
                                    <dxi-item dataField="noTreeOptions" [label]="{ text: 'No Tree Options' }" editorType="dxCheckBox"></dxi-item>
                                    <dxi-item dataField="noOptions" [label]="{ text: 'No Config Options' }" editorType="dxCheckBox"></dxi-item>
                                    <dxi-item dataField="noToonOption" editorType="dxCheckBox"></dxi-item>
                                    <dxi-item
                                        dataField="basePrice"
                                        [label]="{ text: 'Base Price' }"
                                        editorType="dxNumberBox"
                                        [editorOptions]="{ min: 0, format: { type: 'currency', precision: 2 } }"
                                        [colSpan]="3"
                                    ></dxi-item>
                                    <dxi-item
                                        dataField="tailYesPrice"
                                        [label]="{ text: 'Tail Yes Price Increase' }"
                                        editorType="dxNumberBox"
                                        [editorOptions]="{ min: 0, format: { type: 'currency', precision: 2 } }"
                                        *ngIf="modelType?.hasTailOption"
                                    ></dxi-item>
                                    <dxi-item
                                        dataField="toonPontoonPrice"
                                        [label]="{ text: 'Pontoon Price Increase' }"
                                        editorType="dxNumberBox"
                                        [editorOptions]="{ min: 0, format: { type: 'currency', precision: 2 } }"
                                        *ngIf="modelType?.hasToonOption"
                                    ></dxi-item>
                                    <dxi-item
                                        dataField="toonTritoonPrice"
                                        [label]="{ text: 'Tritoon Price Increase' }"
                                        editorType="dxNumberBox"
                                        [editorOptions]="{ min: 0, format: { type: 'currency', precision: 2 } }"
                                        *ngIf="modelType?.hasToonOption"
                                    ></dxi-item>
                                </dxi-item>
                            </dxi-item>
                        </dx-form>
                        <div class="d-flex">
                            <div *ngIf="!modelType?.hasSuspension || modelSize?._tireSizes?.length > 0" class="d-flex flex-column ms-3 me-3">
                                <table class="mt-3 table table-hover table-min-width">
                                    <thead>
                                        Tires
                                        <i class="ms-2 fa fa-plus" (click)="add('Tire')" *ngIf="!modelType?.hasSuspension"></i>
                                    </thead>
                                    <tbody *ngIf="modelSize && modelSize._tireSizes?.length > 0">
                                        <tr *ngFor="let tire of modelSize._tireSizes">
                                            <td (click)="markAsDefault(tire.sizeLinkId, 'Tire')">{{ tire.name }}</td>
                                            <td class="icon-collapse-horizontal">
                                                <i
                                                    [ngClass]="{ fa: true, 'fa-star': tire.isDefault, 'fa-star-o': !tire.isDefault }"
                                                    (click)="markAsDefault(tire.sizeLinkId, 'Tire')"
                                                ></i>
                                            </td>
                                            <td class="icon-collapse-horizontal"><i class="fa fa-times" (click)="deleteSizeLink(tire.sizeLinkId, 'Tire')"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div *ngIf="modelType?.hasBrakes || modelSize?._brakes?.length > 0" class="d-flex flex-column ms-3 me-3">
                                <table class="mt-3 table table-hover table-min-width">
                                    <thead>
                                        Brakes
                                        <i class="ms-2 fa fa-plus" (click)="add('Brake')" *ngIf="modelType?.hasBrakes"></i>
                                    </thead>
                                    <tbody *ngIf="modelSize && modelSize._brakes?.length > 0">
                                        <tr *ngFor="let brake of modelSize._brakes">
                                            <td>{{ brake.name }}</td>
                                            <td class="icon-collapse-horizontal"><i class="fa fa-times" (click)="deleteSizeLink(brake.sizeLinkId, 'Brake')"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div *ngIf="modelType?.hasAxles || modelSize?._axleSizes?.length > 0" class="d-flex flex-column ms-3 me-3">
                                <table class="mt-3 table table-hover table-min-width">
                                    <thead>
                                        Axles
                                        <i class="ms-2 fa fa-plus" (click)="add('Axle')" *ngIf="modelType?.hasAxles"></i>
                                    </thead>
                                    <tbody *ngIf="modelSize && modelSize._axleSizes?.length > 0">
                                        <tr *ngFor="let axle of modelSize._axleSizes">
                                            <td>{{ axle.name }}</td>
                                            <td style="width: 90px;">
                                                <dx-number-box
                                                    [value]="axle.priceIncrease"
                                                    [min]="0"
                                                    [showClearButton]="true"
                                                    placeholder="+$"
                                                    width="85"
                                                    (onValueChanged)="onOptionPriceChanged(axle.sizeLinkId, $event.value)"
                                                ></dx-number-box>
                                            </td>
                                            <td class="icon-collapse-horizontal"><i class="fa fa-times" (click)="deleteSizeLink(axle.sizeLinkId, 'Axle')"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div *ngIf="modelType?.hasSuspension || modelSize?._suspensions?.length > 0" class="d-flex flex-column ms-3 me-3">
                                <table class="mt-3 table table-hover table-min-width">
                                    <thead>
                                        Suspension
                                        <i class="ms-2 fa fa-plus" (click)="add('Suspension')" *ngIf="modelType?.hasSuspension"></i>
                                    </thead>
                                    <tbody *ngIf="modelSize && modelSize._suspensions?.length > 0">
                                        <tr *ngFor="let suspension of modelSize._suspensions">
                                            <td (click)="markAsDefault(suspension.sizeLinkId, 'Suspension')">{{ suspension.name }}</td>
                                            <td style="width: 90px;">
                                                <dx-number-box
                                                    [value]="suspension.priceIncrease"
                                                    [min]="0"
                                                    [showClearButton]="true"
                                                    placeholder="+$"
                                                    width="85"
                                                    (onValueChanged)="onOptionPriceChanged(suspension.sizeLinkId, $event.value)"
                                                ></dx-number-box>
                                            </td>
                                            <td class="icon-collapse-horizontal">
                                                <i
                                                    [ngClass]="{ fa: true, 'fa-star': suspension.isDefault, 'fa-star-o': !suspension.isDefault }"
                                                    (click)="markAsDefault(suspension.sizeLinkId, 'Suspension')"
                                                ></i>
                                            </td>
                                            <td class="icon-collapse-horizontal"><i class="fa fa-times" (click)="deleteSizeLink(suspension.sizeLinkId, 'Suspension')"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div *ngIf="modelType?.hasOptions || modelSize?._options?.length" class="d-flex flex-column ms-3 me-3">
                                <table class="mt-3 table table-hover table-min-width">
                                    <thead>
                                        Config Options
                                        <i class="ms-2 fa fa-plus" (click)="add('Option')" *ngIf="modelType?.hasOptions"></i>
                                    </thead>
                                    <tbody *ngIf="modelSize && modelSize._options?.length > 0">
                                        <tr *ngFor="let option of modelSize._options">
                                            <td (click)="markAsDefault(option.sizeLinkId, 'Option')">{{ option.name }}</td>
                                            <td style="width: 90px;">
                                                <dx-number-box
                                                    [value]="option.priceIncrease"
                                                    [min]="0"
                                                    [showClearButton]="true"
                                                    placeholder="+$"
                                                    width="85"
                                                    (onValueChanged)="onOptionPriceChanged(option.sizeLinkId, $event.value)"
                                                ></dx-number-box>
                                            </td>
                                            <td class="icon-collapse-horizontal">
                                                <i
                                                    [ngClass]="{ fa: true, 'fa-star': option.isDefault, 'fa-star-o': !option.isDefault }"
                                                    (click)="markAsDefault(option.sizeLinkId, 'Option')"
                                                ></i>
                                            </td>
                                            <td class="icon-collapse-horizontal"><i class="fa fa-times" (click)="deleteSizeLink(option.sizeLinkId, 'Option')"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div *ngIf="modelType?.hasWinchStand || modelSize?._winchStands?.length > 0" class="d-flex flex-column ms-3 me-3">
                                <table class="mt-3 table table-hover table-min-width">
                                    <thead style="white-space: nowrap;">
                                        Winch Stand{{
                                            modelSize.standardWinchStandId ? ' Upgrades' : 's'
                                        }}
                                        <i class="ms-1 fa fa-plus" (click)="add('WinchStand')" *ngIf="modelType?.hasWinchStand"></i>
                                    </thead>
                                    <tbody *ngIf="modelSize && modelSize._winchStands?.length > 0">
                                        <ng-container *ngFor="let winchStand of modelSize._winchStands">
                                            <tr>
                                                <td (click)="markAsDefault(winchStand.sizeLinkId, 'WinchStand')">{{ winchStand.name }}</td>
                                                <td style="width: 90px;">
                                                    <dx-number-box
                                                        [value]="winchStand.priceIncrease"
                                                        [min]="0"
                                                        [showClearButton]="true"
                                                        placeholder="+$"
                                                        width="85"
                                                        (onValueChanged)="onOptionPriceChanged(winchStand.sizeLinkId, $event.value)"
                                                    ></dx-number-box>
                                                </td>
                                                <td class="icon-collapse-horizontal">
                                                    <i
                                                        [ngClass]="{ fa: true, 'fa-star': winchStand.isDefault, 'fa-star-o': !winchStand.isDefault }"
                                                        (click)="markAsDefault(winchStand.sizeLinkId, 'WinchStand')"
                                                    ></i>
                                                </td>
                                                <td class="icon-collapse-horizontal"><i class="fa fa-times" (click)="deleteSizeLink(winchStand.sizeLinkId, 'WinchStand')"></i></td>
                                            </tr>
                                            <ng-container *ngIf="winchStand._options?.length > 0">
                                                <tr *ngFor="let option of winchStand._options">
                                                    <td style="padding-left: 30px; font-size: 0.9em; color: #666;">
                                                        {{ option.name }}
                                                    </td>
                                                    <td></td>
                                                    <td class="icon-collapse-horizontal">
                                                        <i [ngClass]="{ fa: true, 'fa-star': option.isDefault, 'fa-star-o': !option.isDefault }"></i>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                            <div *ngIf="modelType?.hasTreeOptions || modelSize?._placeQuantities?.length > 0" class="d-flex flex-column ms-3 me-3">
                                <table class="mt-3 table table-hover table-min-width">
                                    <thead>
                                        Place Qty Options
                                        <i class="ms-2 fa fa-plus" (click)="add('Place Quantities')" *ngIf="modelType?.hasTreeOptions"></i>
                                    </thead>
                                    <tbody *ngIf="modelSize && modelSize._placeQuantities?.length > 0">
                                        <tr *ngFor="let placeQty of modelSize._placeQuantities">
                                            <td>{{ placeQty.name }}</td>
                                            <td style="width: 90px;">
                                                <dx-number-box
                                                    [value]="placeQty.priceIncrease"
                                                    [min]="0"
                                                    [showClearButton]="true"
                                                    placeholder="+$"
                                                    width="85"
                                                    (onValueChanged)="onOptionPriceChanged(placeQty.sizeLinkId, $event.value)"
                                                ></dx-number-box>
                                            </td>
                                            <td class="icon-collapse-horizontal"><i class="fa fa-times" (click)="deleteSizeLink(placeQty.sizeLinkId, 'Place Quantities')"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex flex-column ms-3 me-3">
                                <table class="mt-3 table table-hover table-min-width">
                                    <thead>
                                        Sales Addons
                                        <i class="ms-2 fa fa-plus" (click)="add('SalesAddon')"></i>
                                    </thead>
                                    <tbody *ngIf="modelSize && modelSize._salesAddons?.length > 0">
                                        <tr *ngFor="let addon of modelSize._salesAddons">
                                            <td>{{ addon.name }}</td>
                                            <td></td>
                                            <td class="icon-collapse-horizontal"><i class="fa fa-times" (click)="deleteSizeLink(addon.sizeLinkId, 'SalesAddon')"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!isNew" class="d-flex flex-column col-sm-2">
                <dx-list
                    [items]="modelSizes"
                    [selectionMode]="'multiple'"
                    [keyExpr]="'id'"
                    [displayExpr]="'displayName'"
                    [showSelectionControls]="true"
                    [selectByClick]="true"
                    [(selectedItemKeys)]="selectedModelSizeIds"
                >
                </dx-list>
                <div class="mt-3 text-end">
                    <button class="btn btn-danger" (click)="saveAndApplySelected()">Save and apply to selected</button>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-danger" (click)="save()">Save</button>
            <button class="btn btn-success" (click)="close()">Close</button>
        </div>
    `,
    styles: `
        .table-min-width {
            min-width: 150px;
        }
    `,
    standalone: false,
})
export class ModelSizeDialogComponent {
    appInfo = inject(AppInformationService);
    auth = inject(AuthService);
    uow = inject(GenesisUnitOfWork);
    modalService = inject(BsModalService);

    result = new Subject<{ success: boolean }>();
    modelTypes: PartConfigModelType[];
    modelType: PartConfigModelType;
    modelSize: PartConfigModelSize;
    winchStands: PartConfigWinchStand[];
    allWinchStandOptions: PartConfigWinchStandOption[];
    winchStandOptions: PartConfigWinchStandOption[];
    modelSizes: PartConfigModelSize[];
    selectedModelSizeIds: number[];
    displayOrder: number;
    validationGroup: 'validationGroup';
    canChangeModelType = false;
    isNew = false;
    salesAddons: any[] = [];

    sortOptions() {
        const sortByDefaultAndName = (list) => {
            return list.sort((a, b) => {
                if (a.isDefault !== b.isDefault) {
                    return b.isDefault - a.isDefault;
                }
                return a.name.localeCompare(b.name, undefined, {
                    numeric: true,
                    sensitivity: 'base',
                });
            });
        };

        const sortByName = (list) => {
            return list.sort((a, b) => {
                return a.name.localeCompare(b.name, undefined, {
                    numeric: true,
                    sensitivity: 'base',
                });
            });
        };

        if (this.modelSize._tireSizes) sortByDefaultAndName(this.modelSize._tireSizes);
        if (this.modelSize._suspensions) sortByDefaultAndName(this.modelSize._suspensions);
        if (this.modelSize._options) sortByDefaultAndName(this.modelSize._options);
        if (this.modelSize._winchStands) sortByDefaultAndName(this.modelSize._winchStands);
        if (this.modelSize._axleSizes) sortByName(this.modelSize._axleSizes);
        if (this.modelSize._brakes) sortByName(this.modelSize._brakes);
        if (this.modelSize._placeQuantities) sortByName(this.modelSize._placeQuantities);
        if (this.modelSize._salesAddons) sortByName(this.modelSize._salesAddons);
    }

    async ngOnInit() {
        this.modelTypes = await this.uow.partConfigModelTypes.whereActive();
        this.winchStands = await this.uow.partConfigWinchStands.whereActive();
        this.winchStands.forEach((x) => {
            x.setOptionLinks(x.partConfigWinchStandOptionLinks);
        });
        this.allWinchStandOptions = await this.uow.partConfigWinchStandOptions.whereActive();
        this.winchStandOptions = this.allWinchStandOptions;
        this.salesAddons = (await this.uow.getPartOptions()) as any[];
        const pp1029 = await this.uow.getPartByPartNumber('PP-1029');
        const pp1030 = await this.uow.getPartByPartNumber('PP-1030');
        const pp1031 = await this.uow.getPartByPartNumber('PP-1031');
        const pp1262 = await this.uow.getPartByPartNumber('PP-1262');
        const pp1350 = await this.uow.getPartByPartNumber('PP-1350');
        this.salesAddons.push(pp1029, pp1030, pp1031, pp1262, pp1350);
        await this.getData();
    }

    onModelTypeChanged(e) {
        if (e.value) {
            this.modelType = this.modelTypes.find((x) => x.id === this.modelSize.partConfigModelTypeId);
        } else {
            this.modelType = null;
        }
    }

    onStandardWinchStandChanged(e) {
        this.modelSize.standardWinchStandOptionId = null;
        if (e.value) {
            this.winchStandOptions = this.allWinchStandOptions.filter((x) => this.modelSize.standardWinchStand._options.some((y) => x.id == y.optionId));
        } else {
            this.winchStandOptions = null;
        }
    }

    async getData() {
        if (!this.modelSize) {
            this.modelSize = this.uow.partConfigModelSizes.createEntity({
                displayOrder: this.displayOrder,
                created: new Date(),
                createdBy: this.auth.currentUser?.userName,
            }) as PartConfigModelSize;
            this.canChangeModelType = true;
            this.modelSize._axleSizes = [];
            this.modelSize._tireSizes = [];
            this.modelSize._suspensions = [];
            this.modelSize._options = [];
            this.modelSize._winchStands = [];
            this.modelSize._brakes = [];
            this.modelSize._salesAddons = [];
        } else {
            this.canChangeModelType = false;
            this.modelType = this.modelTypes.find((x) => x.id === this.modelSize.partConfigModelTypeId);
            if (this.modelSize.standardWinchStandId) {
                this.winchStandOptions = this.allWinchStandOptions.filter((x) => this.modelSize.standardWinchStand._options.some((y) => x.id == y.optionId));
            }
            this.modelSizes = (await this.uow.getModelSizesByModelType(this.modelSize.partConfigModelTypeId)).filter((x) => x.id !== this.modelSize.id);
            this.modelSize._salesAddons = (this.modelSize.partConfigSizeLinks ?? [])
                .filter((l) => l.entityTypeName === 'Part' && !l.deleted)
                .map((l) => {
                    const part = this.salesAddons.find((p) => p.id === l.primaryKey);
                    return {
                        entityId: l.primaryKey,
                        sizeLinkId: l.id,
                        name: part ? `${part.partNumber}${part.description ? ' - ' + part.description : ''}` : `Part #${l.primaryKey}`,
                    };
                });
            this.sortOptions();
        }
    }
    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }
    async add(mode?: string) {
        let array = [];
        if (mode === 'Axle') array = await this.uow.partConfigAxles.whereActive();
        if (mode === 'Brake') array = await this.uow.partConfigBrakes.whereActive();
        if (mode === 'Tire') array = await this.uow.partConfigTires.whereActive();
        if (mode === 'Suspension') array = await this.uow.partConfigSuspensions.whereActive();
        if (mode === 'Option') array = await this.uow.partConfigOptions.whereActive();
        if (mode === 'WinchStand') array = await this.uow.partConfigWinchStands.whereActive();
        if (mode === 'Place Quantities') array = await this.uow.partConfigPlaceQuantities.whereActive();
        if (mode === 'SalesAddon') array = this.salesAddons.map((p) => ({ id: p.id, name: `${p.partNumber}${p.description ? ' - ' + p.description : ''}` }));

        array = array.filter((x) => {
            if (mode === 'Axle') return !this.modelSize._axleSizes?.map((y) => y.entityId).includes(x.id);
            if (mode === 'Brake') return !this.modelSize._brakes?.map((y) => y.entityId).includes(x.id);
            if (mode === 'Tire') return !this.modelSize._tireSizes?.map((y) => y.entityId).includes(x.id);
            if (mode === 'Suspension') return !this.modelSize._suspensions?.map((y) => y.entityId).includes(x.id);
            if (mode === 'Option') return !this.modelSize._options?.map((y) => y.entityId).includes(x.id);
            if (mode === 'WinchStand') return !this.modelSize._winchStands?.map((y) => y.entityId).includes(x.id) && x.id !== this.modelSize.standardWinchStandId;
            if (mode === 'Place Quantities') return !this.modelSize._placeQuantities?.map((y) => y.entityId).includes(x.id);
            if (mode === 'SalesAddon') return !this.modelSize._salesAddons?.map((y) => y.entityId).includes(x.id);
        });
        if (array.length === 0) {
            this.appInfo.notifyToast(`No more ${mode}s to add`, 'info');
            return;
        }

        const modalRef = this.modalService.show(InputDialogComponent, {
            class: mode !== 'SalesAddon' ? 'modal-sm' : 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: `Add ${mode}`,
                dialogPrompt: `Add`,
                dialogValueArray: array,
                mode: 'selectWithId',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result && !!result.value) {
                const newLink = this.uow.partConfigSizeLinks.createEntity({
                    partConfigModelSizeId: this.modelSize.id,
                    entityTypeName:
                        mode === 'Axle'
                            ? 'PartConfigAxle'
                            : mode === 'Brake'
                              ? 'PartConfigBrake'
                              : mode === 'Tire'
                                ? 'PartConfigTire'
                                : mode === 'Suspension'
                                  ? 'PartConfigSuspension'
                                  : mode === 'Option'
                                    ? 'PartConfigOption'
                                    : mode === 'WinchStand'
                                      ? 'PartConfigWinchStand'
                                      : mode === 'Place Quantities'
                                        ? 'PartConfigPlaceQuantities'
                                        : mode === 'SalesAddon'
                                          ? 'Part'
                                          : null,
                    primaryKey: result.value,
                    created: new Date(),
                    createdBy: this.auth.currentUser?.userName,
                });
                await this.uow.commit();
                if (mode === 'Axle') this.modelSize._axleSizes.push({ entityId: result.value, name: array.find((x) => x.id === result.value).name, sizeLinkId: newLink.id });
                if (mode === 'Brake') this.modelSize._brakes.push({ entityId: result.value, name: array.find((x) => x.id === result.value).name, sizeLinkId: newLink.id });
                if (mode === 'Tire') this.modelSize._tireSizes.push({ entityId: result.value, name: array.find((x) => x.id === result.value).name, sizeLinkId: newLink.id });
                if (mode === 'Suspension')
                    this.modelSize._suspensions.push({ entityId: result.value, name: array.find((x) => x.id === result.value).name, sizeLinkId: newLink.id });
                if (mode === 'Option') this.modelSize._options.push({ entityId: result.value, name: array.find((x) => x.id === result.value).name, sizeLinkId: newLink.id });
                if (mode === 'WinchStand')
                    this.modelSize._winchStands.push({
                        entityId: result.value,
                        name: array.find((x) => x.id === result.value).name,
                        sizeLinkId: newLink.id,
                        isDefault: false,
                        _options: array.find((a) => a.id === result.value)?._options,
                    } as any);
                if (mode === 'Place Quantities')
                    this.modelSize._placeQuantities.push({ entityId: result.value, name: array.find((x) => x.id === result.value).name, sizeLinkId: newLink.id });
                if (mode === 'SalesAddon')
                    this.modelSize._salesAddons.push({ entityId: result.value, name: array.find((x) => x.id === result.value).name, sizeLinkId: newLink.id });
                await this.getData();
            } else {
                // this.uow.rollback();
            }
            modalRef.hide();
        });
        this.sortOptions();
    }
    async deleteSizeLink(id: number, mode?: string) {
        const result = await confirm(`Are you sure you want to delete this ${mode} from this Model Size?`, `${this.appInfo.settings.company}`);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        const link = await this.uow.partConfigSizeLinks.byId(id);
        if (link) {
            link.deleted = new Date();
            link.deletedBy = this.auth.currentUser?.userName;
            await this.uow.commit();
        }
        if (mode === 'Axle') this.modelSize._axleSizes = this.modelSize._axleSizes.filter((x) => x.sizeLinkId !== id);
        if (mode === 'Brake') this.modelSize._brakes = this.modelSize._brakes.filter((x) => x.sizeLinkId !== id);
        if (mode === 'Tire') this.modelSize._tireSizes = this.modelSize._tireSizes.filter((x) => x.sizeLinkId !== id);
        if (mode === 'Suspension') this.modelSize._suspensions = this.modelSize._suspensions.filter((x) => x.sizeLinkId !== id);
        if (mode === 'Option') this.modelSize._options = this.modelSize._options.filter((x) => x.sizeLinkId !== id);
        if (mode === 'WinchStand') this.modelSize._winchStands = this.modelSize._winchStands.filter((x) => x.sizeLinkId !== id);
        if (mode === 'Place Quantities') this.modelSize._placeQuantities = this.modelSize._placeQuantities.filter((x) => x.sizeLinkId !== id);
        if (mode === 'SalesAddon') this.modelSize._salesAddons = this.modelSize._salesAddons.filter((x) => x.sizeLinkId !== id);

        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async markAsDefault(id: number, mode?: string) {
        let entityTypeName = '';
        if (mode === 'WinchStand') entityTypeName = 'PartConfigWinchStand';
        if (mode === 'WinchStand') entityTypeName = '';

        const link = this.modelSize.partConfigSizeLinks.find((x) => x.id === id);
        const wasDefault = link?.isDefault;
        if (link) {
            // Find all links with the same entityTypeName for this model size
            const allLinks = this.modelSize.partConfigSizeLinks.filter((x) => x.entityTypeName === link.entityTypeName);

            // Unmark all as not default
            allLinks.forEach((l) => {
                l.isDefault = false;
            });

            // Mark the selected one as default only if it wasn't already default
            if (!wasDefault) {
                link.isDefault = true;
            }
            await this.uow.commit();

            // Update UI model
        }

        if (mode === 'Tire')
            this.modelSize._tireSizes.forEach((ws) => {
                (ws as any).isDefault = !wasDefault && ws.sizeLinkId === id;
            });
        if (mode === 'Suspension')
            this.modelSize._suspensions.forEach((ws) => {
                (ws as any).isDefault = !wasDefault && ws.sizeLinkId === id;
            });
        if (mode === 'Option')
            this.modelSize._options.forEach((ws) => {
                (ws as any).isDefault = !wasDefault && ws.sizeLinkId === id;
            });
        if (mode === 'WinchStand')
            this.modelSize._winchStands.forEach((ws) => {
                (ws as any).isDefault = !wasDefault && ws.sizeLinkId === id;
            });
        this.sortOptions();
    }

    onOptionPriceChanged(sizeLinkId: number, value: number | null) {
        const link = this.modelSize.partConfigSizeLinks?.find((x) => x.id === sizeLinkId);
        if (link) link.priceIncrease = value;
        const allLinks = [
            ...(this.modelSize._axleSizes ?? []),
            ...(this.modelSize._brakes ?? []),
            ...(this.modelSize._tireSizes ?? []),
            ...(this.modelSize._suspensions ?? []),
            ...(this.modelSize._options ?? []),
            ...(this.modelSize._winchStands ?? []),
            ...(this.modelSize._placeQuantities ?? []),
        ];
        const localLink = allLinks.find((x) => x.sizeLinkId === sizeLinkId);
        if (localLink) (localLink as any).priceIncrease = value;
    }

    async saveAndApplySelected() {
        if (!this.validate() || !this.selectedModelSizeIds || this.selectedModelSizeIds.length == 0) return;
        this.appInfo.pleaseWaitShow();
        await this.uow.commit();
        const modelSizes = this.modelSizes.filter((x) => this.selectedModelSizeIds.some((y) => y == x.id));
        for (const size of modelSizes) {
            size.noAxles = this.modelSize.noAxles;
            size.noBrakeOption = this.modelSize.noBrakeOption;
            size.noTailOption = this.modelSize.noTailOption;
            size.noPolyCarpetOption = this.modelSize.noPolyCarpetOption;
            size.noSuspension = this.modelSize.noSuspension;
            size.noWinchStand = this.modelSize.noWinchStand;
            size.noTreeOptions = this.modelSize.noTreeOptions;
            size.noOptions = this.modelSize.noOptions;
            size.noToonOption = this.modelSize.noToonOption;
            size.standardWinchStandId = this.modelSize.standardWinchStandId;
            size.standardWinchStandOptionId = this.modelSize.standardWinchStandOptionId;
            size.basePrice = this.modelSize.basePrice;
            size.tailYesPrice = this.modelSize.tailYesPrice;
            size.toonPontoonPrice = this.modelSize.toonPontoonPrice;
            size.toonTritoonPrice = this.modelSize.toonTritoonPrice;
            this.syncSizeLinks(this.modelSize, size);
        }
        await this.uow.commit();
        this.appInfo.pleaseWaitHide();
        this.result.next({ success: true, value: this.modelSize } as any);
    }

    syncSizeLinks(source: PartConfigModelSize, target: PartConfigModelSize) {
        const sourceLinks = source.partConfigSizeLinks.filter((l) => !l.deleted);
        const targetLinks = target.partConfigSizeLinks.filter((l) => !l.deleted);

        targetLinks.forEach((tLink) => {
            const existsInSource = sourceLinks.find((sLink) => sLink.entityTypeName === tLink.entityTypeName && sLink.primaryKey === tLink.primaryKey);
            if (!existsInSource) {
                tLink.deleted = new Date();
                tLink.deletedBy = this.auth.currentUser?.userName;
            }
        });

        sourceLinks.forEach((sLink) => {
            const existingTargetLink = targetLinks.find((tLink) => tLink.entityTypeName === sLink.entityTypeName && tLink.primaryKey === sLink.primaryKey);
            if (existingTargetLink) {
                existingTargetLink.isDefault = sLink.isDefault;
                existingTargetLink.priceIncrease = sLink.priceIncrease;
            } else {
                this.uow.partConfigSizeLinks.createEntity({
                    partConfigModelSizeId: target.id,
                    entityTypeName: sLink.entityTypeName,
                    primaryKey: sLink.primaryKey,
                    isDefault: sLink.isDefault,
                    priceIncrease: sLink.priceIncrease,
                    created: new Date(),
                    createdBy: this.auth.currentUser?.userName,
                });
            }
        });
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true, value: this.modelSize } as any);
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('validationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('validationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
